import React from 'react';

import SurveyQuestionTableRow from './SurveyQuestionTableRow';

class SurveyQuestionTable extends React.Component {
  _onSurveyQuestionChange(ident) {
    return value => {
      this.props.onSurveyQuestionChange(ident, value);
    };
  }


  render() {
    const {
      surveyQuestionRows = [],
      inputId,
      editMode
    } = this.props;

    return (
      <div className="parkchirp--survey-question-table">
        {surveyQuestionRows.map(surveyQuestionRow => {
          return (
            <SurveyQuestionTableRow inputId={inputId}
              key={surveyQuestionRow.ident}
              ident={surveyQuestionRow.ident}
              surveyQuestion={surveyQuestionRow.data}
              onValueChange={this._onSurveyQuestionChange(surveyQuestionRow.ident)}
              editMode={editMode}
            />
          );
        })}
      </div>
    );
  }
}
export default SurveyQuestionTable;
